import React, { memo, useEffect, useState } from "react";
import {
    Typography,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination,
    Tooltip,
    Box,
    CircularProgress,
    IconButton,
    Grid
} from "@mui/material";
import EditIcon from '@mui/icons-material/Edit';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import configServ from "../../../services/config";
import AddItemImage from "./AddItemImage";
import { AddPhotoAlternate } from "@mui/icons-material";
import { cellStyle, evenRowStyle, headerCellStyle, oddRowStyle, rowStyle } from "../../../utility/CustomStyle";

// FUNCTION
const ItemImageList = ({ itemData, pagination = true }) => {
    //#region code
    const rowsPerPageOptions = [5, 10, 50];
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(rowsPerPageOptions[0]);
    const [imageList, setImageList] = useState([]);
    const [editData, setEditData] = useState(null);
    const [isEdit, setIsEdit] = useState(false);
    const [openAddImage, setOpenAddImage] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [isImageChanged, setIsImageChanged] = useState(false);

    const fetchItemImage = async () => {
        try {
            setIsLoading(true);
            const result = await configServ.get_item_img({ "product_id": itemData.id });
            setImageList(result.data);
        }
        catch (err) {
            console.log(err);
        }
        finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        fetchItemImage();
    }, [isImageChanged]);

    const headers = ['IMAGE', 'ALT TEXT', 'STATUS', 'ACTION'];

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const paginatedData = pagination
        ? imageList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
        : imageList;

    const handleEdit = (data) => {
        setEditData(data);
        setIsEdit(true);
        setOpenAddImage(true);
    }

    const handleOpenImage = () => {
        setOpenAddImage(true);
    };

    const handleCloseImage = () => {
        setIsImageChanged(!isImageChanged);
        handleReset();
    };

    const handleReset = () => {
      try{
        setOpenAddImage(false);
        setEditData(null);
        setIsEdit(false);
      }
      catch(e){
        console.log(e);
      }
    }
    
    //#endregion

    return (
        <>
            <AddItemImage itemData={itemData} handleClose={handleCloseImage} open={openAddImage} editData={editData} isEdit={isEdit}/>

            <Grid container item alignItems={'center'} justifyContent={'flex-start'}>
                <IconButton onClick={handleOpenImage} sx={{ fontSize: "36px", p: 0 }} title="Add Image">
                    <AddPhotoAlternate color="warning" fontSize="36px" />
                </IconButton>
            </Grid>
            <TableContainer component={Paper} sx={{ width: '100%' }}>
                <Table stickyHeader>
                    <TableHead>
                        <TableRow>
                            <TableCell sx={headerCellStyle}>S.No.</TableCell>
                            {headers.map((header, index) => (
                                <TableCell key={index} sx={headerCellStyle}>
                                    {header}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {
                            isLoading ?
                                <TableRow>
                                    <TableCell colSpan={6} sx={{ textAlign: 'center' }}>
                                        <Box display="flex" alignItems="center" justifyContent="center">
                                            <CircularProgress />
                                        </Box>
                                    </TableCell>
                                </TableRow>
                                :
                                (
                                    paginatedData.length > 0 ?
                                        paginatedData.map((row, rowIndex) => (
                                            <TableRow key={rowIndex}
                                                sx={{
                                                    ...rowStyle,
                                                    ...(rowIndex % 2 === 0 ? evenRowStyle : oddRowStyle),
                                                }}
                                            >
                                                <TableCell sx={cellStyle}>{page * rowsPerPage + rowIndex + 1}</TableCell>
                                                <TableCell sx={cellStyle}>
                                                    <img
                                                        alt={row.alt}
                                                        src={`data:image/${row.extension};base64,${row.image}`}
                                                        height={100}
                                                    />
                                                </TableCell>
                                                <TableCell sx={cellStyle}>{row.alt}</TableCell>
                                                <TableCell sx={cellStyle}>{Boolean(row.status) === true ? <CheckCircleIcon color='success' /> : <CancelIcon color='error' />}</TableCell>
                                                <TableCell sx={cellStyle}>
                                                    <Box sx={{ borderRadius: 10, width: 'fit-content', transition: '100ms', cursor: 'pointer', padding: 0.5, ":hover": { backgroundColor: '#99999955' } }}>
                                                        <Tooltip title='Edit' arrow>
                                                            <IconButton
                                                                onClick={() => { handleOpenImage(); handleEdit(row) }}
                                                            >
                                                                <EditIcon />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </Box>
                                                </TableCell>
                                            </TableRow>
                                        ))
                                        :
                                        <TableRow>
                                            <TableCell colSpan={6} sx={{ textAlign: 'center' }}>
                                                <Box display="flex" alignItems="center" justifyContent="center">
                                                    <Typography variant="body1" color={'red'} fontWeight={700}>No image found.</Typography>
                                                </Box>
                                            </TableCell>
                                        </TableRow>
                                )
                        }
                    </TableBody>

                </Table>
                {pagination && (
                    <TablePagination
                        rowsPerPageOptions={rowsPerPageOptions}
                        component="div"
                        count={imageList.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                )}
            </TableContainer>
        </>
    )
}
export default memo(ItemImageList);